import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		title: {
			marginBottom: theme.spacing(4),
		},
		slider: {
			'& .slick-list': {
				margin: 0,

				'& .slick-slide > div': {
					paddingRight: theme.spacing(5),

					[theme.breakpoints.down('sm')]: {
						paddingRight: 0,
					},
				},
			},
		},
	}),
	{ name: 'Testimonials7-Cards' },
)

export default useStyles
